import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoyaltyIconComponent } from './loyalty-icon.component';

@NgModule({
  declarations: [LoyaltyIconComponent],
  imports: [CommonModule],
  exports: [LoyaltyIconComponent],
})
export class LoyaltyIconModule {}
